import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faMicrochip, faMobileScreenButton, faServer, faGlobeAmericas } from "@fortawesome/free-solid-svg-icons"
import { useTranslation, Trans } from "react-i18next"
import TransLink from "../components/TransLink"

export default function Brochure() {
  const { t } = useTranslation()

  return (
    <div className="a4-wrapper red-box">

      <img      
        src="/images/aboveTheFoldMobile.webp"
        alt="Mobile hero"
        className="above-the-fold-img"
      />

      <nav className="brochure-wrapper">
        <img className="brochure-logo" src="/images/logoCyan.webp" alt="bitsAndBoltsLogo" />
        <div className="logo-name-wrapper">
          <div className="brochure-logo-name-line-1">BITS & BOLTS</div>
          <div className="brochure-logo-name-line-2">FROM IDEA TO LAUNCH</div>
        </div>        
      </nav>
      

      <main className="brochure-main">
        <section className="brochure-layout">
          <div className="brochure-left red-box">
            <div className="brochure-social-proof-pill">
              <img 
                src="/images/upwork_jss.webp" 
                alt="Upwork 100% Job Success" 
                className="upwork-icon"                
              />
              <span style={{ textAlign: "center" }}>
                100% Upwork Job Success Score <br /> 20+ projects with 5⭐ reviews
              </span>
            </div>

            <div className="brochure-headline neon-glow">
              <Trans i18nKey="headline" />
            </div>

            <div className="borchure-you-will-read-this-third">
              {t("subHeadline")}
            </div>
            <div className="borchure-you-will-read-this-third">
              {t("reduceFUD")}
            </div>
          </div>

          <TransLink t="quoteIntro" textStyle="borchure-you-will-read-this-third" linkStyle="project-link" />

              <p className="borchure-you-will-read-this-third">
                <FontAwesomeIcon icon={faMicrochip} className="quote-icon" /> {t("quoteLine1")}
              </p>
              <p className="borchure-you-will-read-this-third">
                <FontAwesomeIcon icon={faMobileScreenButton} className="quote-icon" /> {t("quoteLine2")}
              </p>
              <p className="borchure-you-will-read-this-third">
                <FontAwesomeIcon icon={faServer} className="quote-icon" /> {t("quoteLine3")}
              </p>
              <p className="borchure-you-will-read-this-third">
                <FontAwesomeIcon icon={faGlobeAmericas} className="quote-icon" />
                <TransLink t="quoteLine4" textStyle="borchure-you-will-read-this-third" linkStyle="project-link" />
              </p>

              <p className="borchure-you-will-read-this-third">
                {t("quoteFinalMessage")}
              </p>
          

          <div className="brochure-right">
            <img
              src="/images/quote_picture.webp"
              alt={t("quoteImageAlt")}
              className="brochure-floating-image"
            />
           
          </div>
        </section>
      </main>
    </div>
  )
}